import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { WidgetBox } from '../components/dashboard/dashboardWidgets';

interface StatsLayoutStore {
  /** Place de chaque bloc de la page Statistiques, par collaborateur. */
  boxesByCollaborator: Record<string, Record<string, WidgetBox>>;
  setBoxes: (collaboratorId: string, boxes: Record<string, WidgetBox>) => void;
  reset: (collaboratorId: string) => void;
}

export const useStatsLayoutStore = create<StatsLayoutStore>()(
  persist(
    (set) => ({
      boxesByCollaborator: {},

      setBoxes: (collaboratorId, boxes) =>
        set((state) => ({
          boxesByCollaborator: {
            ...state.boxesByCollaborator,
            [collaboratorId]: { ...state.boxesByCollaborator[collaboratorId], ...boxes },
          },
        })),

      reset: (collaboratorId) =>
        set((state) => {
          const next = { ...state.boxesByCollaborator };
          delete next[collaboratorId];
          return { boxesByCollaborator: next };
        }),
    }),
    { name: 'cime.stats.layout' },
  ),
);
